import React from 'react';
import { Link } from 'react-router-dom';
import products from '../../data/products';
import './Products.css';

const Products: React.FC = () => {
  return (
    <section className="products" id="products">
      <div className="products-container">
        <h2>Our Products</h2>
        <div className="products-grid">
          {products.map((product) => (
            <Link to={`/product/${product.id}`} key={product.id} className="product-card">
              <div className="product-image">
                <img src={product.image} alt={product.name} />
              </div>
              <h3>{product.name}</h3>
              <div className="product-names">
                <h4 className="english-name">{product.englishName}</h4>
                <h4 className="hindi-name">({product.hindiName})</h4>
              </div>
              <p className="description">{product.description.slice(0, 80)}...</p>
              <div className="benefits">
                <h4>Key Benefits:</h4>
                <ul>
                  {product.benefits.map((benefit, index) => (
                    <li key={index}>{benefit}</li>
                  ))}
                </ul>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
